import classes from "./InputAdornment.module.scss";
import { clsx } from "clsx";
import { InputAdornmentProps } from "./InputAdornmentProps";

export function InputAdornment(props: InputAdornmentProps) {
  const { position, className, isInteractive, ...htmlProps } = props;

  const rootClassName = clsx(classes.base, className, {
    [classes.start]: position === "start",
    [classes.end]: position === "end",
    [classes.pointerEventNone]: !isInteractive,
  });

  return <div className={rootClassName} {...htmlProps} />;
}
